module.exports = __webpack_public_path__ + "img/icon_img04.7b07396b.png";